
import ToastBase from "@/common/ToastBase.vue";
export default {
  extends: ToastBase,

  filters: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
